import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import Header from "../HeaderComponent/Header";
import history from "../../auth/history";
import FooterComponet from "../FooterComponent/FooterComponet";

import { v4 as uuidv4 } from 'uuid';
import { store } from "../../redux/store";
import { setAddSenderRequest, setAddSenderRequestUrl } from "../../redux/misc-data/misc-data.action";
import { setOtpResponse } from "../../redux/misc-data/misc-data.action";
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import { setSenderCustomerId } from './../../redux/misc-data/misc-data.action';
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";
const httpClient = axios.create();

class AddSender extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			senderNameValue: '',
			senderMobileNo: '',
			senderGovtIdType: '',
			senderGovtIdNumber: '',
			uploadedGovtId: '',
			govtIdTypeInvalidSelectionMessage: '',
			gIdValues: [
				{ value: "Select", label: "Select" },
				{ value: "AADHAAR_CARD", label: "Aadhaar Card" },
				{ value: "BILL_ADDRESS_PROOF", label: "Voter ID" },
				{ value: "DRIVERS_LICENSE", label: "Driving License" },
				{ value: "PAN_CARD", label: "PAN card" },
				{ value: "PASSPORT", label: "Passport" }
			],
			errorMessage: '',

			//file upload setting
			uploadErrorMessage: '',
			progress: 0,
			selectedFile: null,
			removeStatus: false,
			imageUrl: '',
			progress:''
		}
	}

	senderName = (event) => {

		var senderName = '';

		var senderNameArray = event.target.value.split(" ");


		for (let i = 0; i < senderNameArray.length; i++) {
			senderName = senderName + " " + senderNameArray[i].toString().charAt(0).toUpperCase() +
				senderNameArray[i].substring(1, senderNameArray[i].length).toLowerCase();

		}
		console.log(senderName);
		senderName = senderName.trim();
		this.setState({
			senderNameValue: senderName
		})
	}


	dropHandler = (ev) => {
		console.log('File(s) dropped');
		ev.preventDefault();
		if (ev.dataTransfer.items) {
			for (var i = 0; i < ev.dataTransfer.items.length; i++) {
				if (ev.dataTransfer.items[i].kind === 'file') {
					var file = ev.dataTransfer.items[i].getAsFile();
					console.log('... file[' + i + '].name = ' + file.name);
				}
			}
		} else {
			for (var i = 0; i < ev.dataTransfer.files.length; i++) {
				console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
			}
		}
	}
	dragOverHandler = (ev) => {
		console.log('File(s) in drop zone');
		ev.preventDefault();
	}

	onFileChange = (event) => {
		this.setState({
			uploadErrorMessage: ''
		})

		if (event != null) {
			if (event.target != null) {

				console.log('event.....' + JSON.stringify(event.target.files[0].type));
				if (event.target.files[0].type.includes("image/jpeg")
					|| event.target.files[0].type.includes("image/gif")
					|| event.target.files[0].type.includes("image/png")
					|| event.target.files[0].type.includes("image/jpg")
				) {
					if (parseInt(event.target.files[0].size / 1000) <= 2 * 1024) {

						if (event.target.files[0] != null) {

							console.log('event.target.files[0]' + URL.createObjectURL(event.target.files[0]));
							this.setState({
								selectedFile: URL.createObjectURL(event.target.files[0])
							});
							this.onFileUpload(event.target.files[0]);
						}
					} else {

						this.setState({
							uploadErrorMessage: 'file size is greater than 2 MB'
						})
					}
				} else {
					console.log("file type is::" + event.target.files[0].type + " only .jpg,.png, .gif supported");
					this.setState({
						uploadErrorMessage: "Only .JPG, .JPG , .GIF file type is supported"
					})
				}
			}
		}

	}


	onFileUpload = (value) => {
		var fileName = uuidv4() + value.name;
		this.setState({
			progress: 0
		})
		console.log('file name::' + value.name);

		const formData = new FormData();

		formData.append(
			"file", value
		);
		formData.append(
			"fileName", fileName
		);

		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id
			, 'role': this.props.clientRole
		}
		fetch('/api/v1/file/upload/uploadImage', {
			method: 'post',
			body: formData,
			headers: headers
		}).then(res => {
			this.setState({
				progress: 50
			})

			if (res.ok) {
				console.log('file upload response:' + JSON.stringify(res));

				alert("File uploaded successfully.");
				this.setState({
					progress: 100
				})

				var url = URL.createObjectURL(value).substring(5, value.length).toString();
				console.log('url....' + url);
				var test = new URL(url);
				console.log('test....' + test);
				console.log('short...' + test.protocol + '//' + test.host + '/files/' + value.name + '/read');

				this.setState({
					imageUrl: fileName
				})
			}
		}).catch(errorx => {
			console.log('file upload error..' + errorx);
		});
	}

	removeImage = (event) => {
		console.log('removeImage');
		this.setState({
			removeStatus: true,
			selectedFile: null
		})
	}


	senderMobile = (event) => {
		this.setState({
			senderMobileNo: event.target.value
		})
	}


	govtIdTypeSelect = (event) => {
		if (event.target.value == 'Select') {
			alert('Please select a Government Id');
			this.setState({
				senderGovtIdType: '',
			})

		} else {
			this.setState({
				senderGovtIdType: event.target.value,
				senderGovtIdNumber: ''
			})
		}
	}

	senderIdNumber = (event) => {
		this.setState({
			senderGovtIdNumber: event.target.value
		})
	}

	validateMobile = () => {
		if (this.state.senderMobileNo.length == 10 &&
			this.state.senderMobileNo >= 6000000000
			&& this.state.senderMobileNo <= 9999999999) {
			return true;

		} else {
			alert('Please enter valid mobile No');
			return false;
		}

	}

	addSenderDetails = (event) => {
		event.preventDefault();

		this.setState({
			progress:'started'
		})

		var nameResult = this.validateName();
		var govtIdResult = this.validateGovernmentId();
		var mobileValidation = this.validateMobile();
		if (nameResult == true && govtIdResult == true
			&&
			mobileValidation == true
			&& this.state.senderGovtIdType != '') {

			const addSenderRequestHeader = {
				msgType: "CREATE_ACCOUNTS",
				service: "DMT",
				src: "review-sender",
				dst: "sender-details",
				channel: "WHITELABEL",
				requesterId: this.props.clientRequesterId,
				requestId: uuidv4(),
				traceId: uuidv4(),
			}

			const generateOtprRequestHeader = {
				msgType: "GENERATE_OTP",
				service: "DMT",
				src: "add-sender",
				dst: "review-sender",
				channel: "WHITELABEL",
				requesterId: this.props.clientRequesterId,
				requestId: uuidv4(),
				traceId: uuidv4(),
			}

			const kyc = {
				type: this.state.senderGovtIdType,
				id: this.state.senderGovtIdNumber,
				url: this.state.imageUrl

			}
			const customer = {
				name: this.state.senderNameValue,
				mobile: this.state.senderMobileNo,
				kyc: kyc,
				addedBy: this.props.agentInfo.id

			}

			const otp = {
				mobile: this.state.senderMobileNo,
				type: "REGISTER_DMT_CUSTOMER"
			}

			const addSenderRequest = {
				header: addSenderRequestHeader,
				customer: customer,
				deviceInfo: this.props.deviceInfo,
				otp: otp
			}

			const generateOtpRequest = {
				header: generateOtprRequestHeader,
				otpDetails: otp
			}

			const url = "/api/v1/dmt/customer/register";


			const otpUrl = "/api/v1/otp/generate";

			const headers = {
				'Authorization': 'Bearer ' + this.props.token,
				'client-id': this.props.agentInfo.id,
				'role': this.props.clientRole
			}


			httpClient.post(otpUrl, generateOtpRequest,
				{ headers }
			).then((response) => {
				console.log('otp generate response' + JSON.stringify(response.data));
				if (response.data.response.msg == 'SUCCESS') {

					this.setState({
						progress:'completed'
					})
					store.dispatch(setAddSenderRequest(addSenderRequest));
					store.dispatch(setAddSenderRequestUrl(url));
					store.dispatch(setOtpResponse(response.data));

					var senderreview = document.getElementById('senderreview');
					senderreview.click();
				}
				else {

					this.setState({
						progress:'completed'
					})
					this.errorMessageCall(response.data.response.displayMsg);
				}
			}).catch(error => {
				this.errorMessageCall(error.message);
			
				if (error.message.includes("401")) {
					tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
				} else {

				}

			});

		} else {

		}
	}

	errorMessageCall(error) {
		this.setState({
			errorMessage: error
		}
		)
	}



	componentDidMount() {
		store.dispatch(setAddSenderRequest(''));
		store.dispatch(setSenderCustomerId(''));

	}
	componentWillUnmount() {
	}



	validateName() {
		// var regName = /^[a-zA-Z]+ [a-zA-Z]+$/;
		var regName = /^[a-zA-Z ]*$/;
		var name = this.state.senderNameValue;

		var regexp = /\b[^\d\s]+\b/g;
		var count = 0;
		while (regexp.exec(name)) {
			++count;
		}

		var nameArray = name.split(" ");
		for (let i = 0; i < nameArray.length; i++) {
			if (nameArray[i].length <= 2) {
				alert('Each word in name should contains more than two characters and one space between them');
				return false;
			}
		}

		if (!regName.test(name)) {
			alert('Name should contains alphabets only');
			return false;
		} else if (count < 2) {
			alert('Please enter at least two words');
			return false;
		} else {
			return true;
		}
	}

	validateGovernmentId() {
		var aadhRegx = /^([2-9]{1}[0-9]{3})([0-9]{4}[0-9]{4})$/;
		var voterRegx = /^([a-zA-Z]){3}([0-9]){7}?$/;
		var drivingLicenseRegex = /^([A-Z]{2})(\d{2}|\d{3})[a-zA-Z]{0,1}(\d{4})(\d{7})$/;
		var panCardRegex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
		var passportRegex = /^(?!^0+$)[a-zA-Z0-9]{6,9}$/;
		var regexVal = "";
		var regexFormat = "";
		var idName = '';

		if (this.state.senderGovtIdType == "AADHAAR_CARD") {
			regexVal = aadhRegx;
			regexFormat = '';
			idName = 'Aadhar Card';
		} else
			if (this.state.senderGovtIdType == "BILL_ADDRESS_PROOF") {
				regexVal = voterRegx;
				regexFormat = 'xxxxxxxxx';
				idName = 'Voter Card';

			} else if (this.state.senderGovtIdType == "DRIVERS_LICENSE") {
				regexVal = drivingLicenseRegex;
				regexFormat = '';
				idName = 'Driving License';
			} else if (this.state.senderGovtIdType == "PAN_CARD") {
				regexVal = panCardRegex;
				regexFormat = 'xxxxxxxxx';
				idName = 'PAN Card';
			} else if (this.state.senderGovtIdType == "PASSPORT") {
				regexVal = passportRegex;
				regexFormat = '';
				idName = 'Passport';
			}

		var govtIdValue = this.state.senderGovtIdNumber;

		if (this.state.senderGovtIdType != "" && this.state.senderGovtIdType != "Select") {
			if (!regexVal.test(govtIdValue)) {
				if (regexFormat != '') {
					alert('Please enter valid ' + idName + ' value in given format ' + regexFormat);
				} else {
					alert('Please enter valid ' + idName + ' value');
				}
				return false;
			}
			else {
				// alert('Valid Id details given.');
				return true;
			}
		} else {
			alert('Please select any government Id.');
		}
	}
	removeUploadZone = (event) => {
		console.log('removeUploadZone');
		this.setState({
			removeStatus: false,
			selectedFile: null
		})

	}



	render() {


		return (
			<div>
				<HeaderCommon />
				<Menu />
				<div class="main">
					<div class="container-fluid">
						<div class="row">
							<div class="col-12">
								<div class="card-b" id="rightdiv">
									<div id="recenttxn">
										<div class="head">
											<h3>Add Sender</h3>
											<div class="headbtn">
												<Link to='/dmt'>
													<button class="dbbtn" type="button">Back</button>
												</Link>
												<Link to='/sender-review'>
													<button id='senderreview' hidden={true}></button>
												</Link>
											</div>
										</div>
										<form onSubmit={this.addSenderDetails}>
											<div class="dashform">
												<div class="row">
													<div class="col-12 col-lg-8">

														<div class="row">
															<div class="col-12 col-sm-6">
																<div class="form-floating">
																	<input type="text" class="form-control" id="nmae" placeholder="Sender Name"
																		onChange={this.senderName}
																		required />
																	<label for="nmae">Sender Name*</label>
																</div>
															</div>

															<div class="col-12 col-sm-6">
																<div class="form-floating">
																	<input type="number" class="form-control" id="mobile" placeholder="Mobile"
																		onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
																		onChange={this.senderMobile}
																		required />
																	<label for="mobile">Mobile Number*</label>
																</div>
															</div>

															{this.state.govtIdTypeInvalidSelectionMessage}

															<div class="col-12 col-sm-6">
																<div class="form-floating">
																	<select class="form-select" id="gid" aria-label=""
																		onChange={this.govtIdTypeSelect} required>
																		{this.state.gIdValues.map(gid => (
																			<option value={gid.value}
																			>{gid.label}</option>
																		))}
																	</select>
																	<label for="gid">Select Government ID*</label>
																</div>
															</div>
															{(
																this.state.senderGovtIdType != '') &&
																<div class="col-12 col-sm-6">
																	<div class="form-floating">
																		<input type="text" class="form-control" id="txnid" placeholder="ID Number"
																			onInput={(e) => e.target.value = e.target.value.slice(0, 20)}
																			onChange={this.senderIdNumber}
																			value={this.state.senderGovtIdNumber}
																			required />
																		<label for="txnid">ID Number*</label>
																	</div>
																</div>
															}

															{
																this.state.senderGovtIdType == '' &&
																<div class="col-12 col-sm-6">
																	<div class="form-floating">
																		<input type="text" class="form-control" id="txnid" placeholder="ID Number"
																			readOnly />
																		<label for="txnid">ID Number</label>
																	</div>
																</div>
															}
														</div>
													</div>




													<div class="col-12 col-lg-4">
														{this.state.uploadErrorMessage != '' &&
															<div class='valid-error'>
																{this.state.uploadErrorMessage}
															</div>
														}
														<div class="file-upload">

															<div class="dropzone-wrapper">
																<div class="dropzone-desc">
																	<i class="camera"></i>
																	<h6>Drag & Drop or <span>Browse</span> Government Id</h6>
																	<br />
																	{!this.state.selectedFile &&
																		<p>File: jpg, png, gif and max size 2 MB</p>
																	}

																	<div id="drop_zone" onDrop={this.dropHandler} onDrag={this.dragOverHandler}>
																	</div>

																</div>
																<input type="file" name="fileup" class="dropzone" onChange={this.onFileChange} />

															</div>
															{this.state.selectedFile &&
																<div class="preview-zone">
																	<div class="box">
																		<div class="progress" style={{ height: 6 + "px" }}>
																			<div class="progress-bar" role="progressbar"
																				style={{ width: this.state.progress + "%" }}
																				aria-valuenow="25" aria-valuemin="0"
																				aria-valuemax="100"></div>
																		</div>
																		<div class="box-body"></div>
																		<img src={this.state.selectedFile} alt="" width="100" />
																		<button type="button" class="remove-preview" onClick={this.removeImage}> Remove</button>
																	</div>
																</div>
															}

														</div>
													</div>


													<div class="col-12">
														<button type="submit" class="btn btn-primary"
														disabled={this.state.progress=='loading'?true:false}
														>Continue</button>
													</div>
													{this.state.errorMessage != '' &&
														<div class='valid-error'>{this.state.errorMessage}</div>}
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>

				<FooterComponet />
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, deviceInfo, agentInfo, token, clientRole, clientRequesterId, callBackUrl } }
	,
) => ({
	errorMessage, loginErrorMessage, phone, deviceInfo, agentInfo, token, clientRole,
	clientRequesterId, callBackUrl
});

export default connect(mapStateToProps, null)(AddSender);
